// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2xwKt","boxTitle":"Qualiphy_boxTitle__20SWH","box":"Qualiphy_box__oqP8v","toggleWrap":"Qualiphy_toggleWrap__RETMu"};